import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VueI18nFilter from 'vue-i18n-filter'
import messages from './messages'
import formMessages from './formMessages'
import _ from 'lodash'

Vue.use(VueI18n)
Vue.use(VueI18nFilter)

const localLang = localStorage.getItem('lang')

const i18n = new VueI18n({
  locale: localLang || 'pt-BR',
  fallbackLocale: 'en',
  messages: _.merge(messages, formMessages)
})

window.$i18n = i18n

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js